export default {"src":"/_next/static/media/icon_x_no_padding.015e1c51.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};